module.exports = __webpack_public_path__ + "img/11-3.f2b6d60e.png";